<app-dialog
  #dialog
  [key]="'share-meeting'"
  [action]="'share-meeting'"
  [headerTheme]="'simple'"
  [title]="'Compartilhar meeting'"
  [maxWidth]="'720px'">
  <div class="share">
    @if (ligacao(); as meeting) {
      <div class="share__meeting">
        <span class="share__meeting-icon" aria-hidden="true"><i class="pi pi-video"></i></span>
        <div>
          <strong>{{ meeting.title }}</strong>
          <span>{{ meeting.scheduledStartAt | vaultDateTime }}</span>
        </div>
      </div>
    }

    @if (carregando() && !compartilhamento()) {
      <app-loading />
    } @else {
      <!-- Time inteiro (acesso geral, cards 3162 e 3191) -->
      @if (compartilhamento()?.canBeShared || compartilhamento()?.isShared) {
        <section class="share__grupo share__grupo--linha" aria-labelledby="share-time">
          <div>
            <h4 class="share__titulo" id="share-time">
              <i class="pi pi-globe" aria-hidden="true"></i> Time inteiro da Legatus
            </h4>
            <p class="share__descricao">
              @if (compartilhamento()?.isShared) {
                Todo o time interno vê esta meeting. Qualquer participante pode desfazer.
              } @else {
                Só quem participou e as pessoas abaixo veem esta meeting.
              }
            </p>
          </div>
          <app-button
            [label]="compartilhamento()?.isShared ? 'Voltar a privada' : 'Liberar para o time'"
            [icon]="compartilhamento()?.isShared ? 'pi pi-lock' : 'pi pi-globe'"
            [theme]="'outline-grey'"
            [disabled]="gravando()"
            [type]="'button'"
            (sendButtonClick)="alternarAcessoGeral()" />
        </section>
      }

      <!-- Pessoas -->
      <section class="share__grupo" aria-labelledby="share-pessoas">
        <h4 class="share__titulo" id="share-pessoas">
          <i class="pi pi-user-plus" aria-hidden="true"></i> Pessoas
        </h4>
        <p class="share__descricao">
          Só o time interno da Legatus. Quem recebe vê a meeting como quem participou, com o vídeo e
          a transcrição.
        </p>
        <div class="share__adicionar">
          <app-select
            class="share__select"
            [multiple]="true"
            [label]="'Compartilhar com'"
            [placeholder]="'Escolha pessoas do time'"
            [options]="opcoes()"
            [emptyMessage]="'Ninguém mais para escolher.'"
            [ngModel]="escolhidas()"
            (ngModelChange)="escolhidas.set($event ?? [])" />
          <app-button
            [label]="'Compartilhar'"
            [icon]="'pi pi-send'"
            [disabled]="!isFormValid()"
            [isLoading]="gravando()"
            [type]="'button'"
            (sendButtonClick)="submitAction()" />
        </div>

        @if (compartilhamento()?.people?.length) {
          <ul class="share__pessoas">
            @for (p of compartilhamento()!.people; track p.userId) {
              <li class="share__pessoa">
                <div class="share__pessoa-dados">
                  <strong>{{ p.name }}</strong>
                  <span>
                    @if (p.email) {
                      {{ p.email }} ·
                    }
                    @if (p.viaLink) {
                      entrou pelo link
                      @if (p.expiresAt) {
                        , até {{ p.expiresAt | vaultDateTime }}
                      }
                    } @else {
                      desde {{ p.grantedAt | vaultDate }}
                    }
                  </span>
                </div>
                <button
                  type="button"
                  class="share__remover"
                  [disabled]="gravando()"
                  [attr.aria-label]="'Tirar o acesso de ' + p.name"
                  (click)="tirarAcesso(p)">
                  <i class="pi pi-times" aria-hidden="true"></i> Tirar acesso
                </button>
              </li>
            }
          </ul>
        } @else {
          <p class="share__vazio">Ainda não foi compartilhada com ninguém.</p>
        }
      </section>

      <!-- Link -->
      <section class="share__grupo" aria-labelledby="share-link">
        <h4 class="share__titulo" id="share-link">
          <i class="pi pi-link" aria-hidden="true"></i> Link de acesso
        </h4>
        <p class="share__descricao">
          Quem do time interno abrir o link passa a ver a meeting até o prazo. Revogar corta o
          acesso de quem entrou por ele.
        </p>

        @if (compartilhamento()?.activeLink; as link) {
          <div class="share__link-ativo">
            <div>
              <strong>Link ativo</strong>
              <span>
                @if (link.expiresAt) {
                  vale até {{ link.expiresAt | vaultDateTime }}
                } @else {
                  sem prazo
                }
                · {{ link.activeUsers }}
                {{ link.activeUsers === 1 ? 'pessoa entrou' : 'pessoas entraram' }}
                @if (link.createdByName) {
                  · gerado por {{ link.createdByName }}
                }
              </span>
            </div>
            <app-button
              [label]="'Revogar'"
              [icon]="'pi pi-ban'"
              [theme]="'outline-grey'"
              [disabled]="gravando()"
              [type]="'button'"
              (sendButtonClick)="revogarLink()" />
          </div>
        }

        @if (urlGerada(); as url) {
          <div class="share__url">
            <code>{{ url }}</code>
            <app-button
              [label]="'Copiar'"
              [icon]="'pi pi-copy'"
              [theme]="'outline-grey'"
              [type]="'button'"
              (sendButtonClick)="copiar(url)" />
          </div>
          <p class="share__aviso">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            Copie agora: por segurança, o link não aparece de novo. Se perder, gere outro.
          </p>
        }

        <div class="share__gerar">
          <app-select
            class="share__prazo"
            [label]="'Prazo'"
            [options]="prazos"
            [ngModel]="prazo()"
            (ngModelChange)="prazo.set($event)" />
          <app-button
            [label]="compartilhamento()?.activeLink ? 'Gerar novo link' : 'Gerar link'"
            [icon]="'pi pi-link'"
            [isLoading]="gravando()"
            [type]="'button'"
            (sendButtonClick)="gerarLink()" />
        </div>
        @if (compartilhamento()?.activeLink) {
          <p class="share__nota">
            Gerar um novo desativa a URL atual; quem já entrou por ela mantém o acesso até o prazo.
          </p>
        }
      </section>

      <!-- Acessos -->
      <section class="share__grupo" aria-labelledby="share-acessos">
        <h4 class="share__titulo" id="share-acessos">
          <i class="pi pi-history" aria-hidden="true"></i> Quem acessou
          @if (totalDeAcessos()) {
            <span class="share__contagem">{{ totalDeAcessos() }}</span>
          }
        </h4>
        <p class="share__descricao">Só quem participou da meeting vê esta lista.</p>

        @if (acessos().length) {
          <ol class="share__acessos">
            @for (a of acessosVisiveis(); track $index) {
              <li class="share__acesso">
                <i
                  class="pi share__acesso-icone"
                  [ngClass]="iconeDaAcao(a.action)"
                  aria-hidden="true"></i>
                <span class="share__acesso-texto">
                  <strong>{{ a.userName }}</strong> · {{ rotuloDaAcao(a.action) }}
                  <span class="share__via">({{ rotuloDaVia(a.via) }})</span>
                </span>
                <span class="share__acesso-hora">{{ a.at | vaultDateTime }}</span>
              </li>
            }
          </ol>
          @if (acessosOcultos()) {
            <button
              type="button"
              class="share__toggle"
              (click)="verTodosOsAcessos.set(!verTodosOsAcessos())">
              <i
                class="pi"
                [class.pi-chevron-down]="!verTodosOsAcessos()"
                [class.pi-chevron-up]="verTodosOsAcessos()"
                aria-hidden="true"></i>
              {{
                verTodosOsAcessos()
                  ? 'Mostrar menos'
                  : 'Ver todos (' + acessosOcultos() + ' a mais)'
              }}
            </button>
          }
        } @else {
          <p class="share__vazio">Nenhum acesso registrado ainda.</p>
        }
      </section>
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <p class="dialog__footer-note">
        <i class="pi pi-lock" aria-hidden="true"></i>
        Parceiros e usuários de empresa não recebem nem abrem o link.
      </p>
      <div class="dialog__footer-actions">
        <app-button
          [label]="'Fechar'"
          [theme]="'outline-grey'"
          [type]="'button'"
          (sendButtonClick)="fechar()" />
      </div>
    </div>
  </ng-template>
</app-dialog>
